module.exports = __webpack_public_path__ + "media/images/icons/switch-icon-a019508d5fcb10a09393ebd6a9e5595c.svg";